import React from 'react';

export const ErrorPageComponent = () => {

    return (
        <div>Error</div>
    )
}